import { FC } from "react";
import { pluralize } from "@/modules/pluralize";
import {
  MDSIcon,
  MDSIconKind,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
  MDSToggle,
} from "@/mds";
import {
  StyledWrapper,
  StyledLeftContainer,
  StyledRightContainer,
  StyledSwitchFloaty,
} from "./search-page-floaty.style";

export interface SearchPageFloatyViewProps {
  isVisible: boolean;
  deepSearchResultsCount: number;
  isShowingDeepSearchResults: boolean;
  isSelected: boolean;
  onToggleChange: (checked: boolean) => void;
}

export const SearchPageFloatyView: FC<SearchPageFloatyViewProps> = ({
  isVisible,
  deepSearchResultsCount,
  isShowingDeepSearchResults,
  isSelected,
  onToggleChange,
}) => {
  const prefix = isShowingDeepSearchResults ? "Showing" : "Show";
  const deepSearchResultsLabel = `${prefix} ${deepSearchResultsCount} Deep Search ${pluralize(
    deepSearchResultsCount,
    "result",
    "results"
  )}`;

  return (
    <StyledWrapper $isVisible={isVisible}>
      <StyledSwitchFloaty data-selected={isSelected}>
        <StyledLeftContainer>
          <MDSIcon kind={MDSIconKind.Radar} />
          <MDSText
            variant={MDSTextVariant.TextS}
            weight={MDSTextWeight.Smedium}
            color={isSelected ? MDSTextColor.Emphasis : MDSTextColor.Primary}
          >
            {deepSearchResultsLabel}
          </MDSText>
        </StyledLeftContainer>
        <StyledRightContainer>
          <MDSToggle checked={isSelected} onChange={e => onToggleChange(e.target.checked)} />
        </StyledRightContainer>
      </StyledSwitchFloaty>
    </StyledWrapper>
  );
};
